import React from 'react'
import { formatDistanceToNow } from 'date-fns'
import { es } from 'date-fns/locale'

import { PropsSectionTree } from 'src/types/contenfull'
import {
    Container,
    ContentInformation,
    Image,
    OverSpan,
    TitleTypography,
    DateAndCreation,
    ImageIcon,
    TypographyDate,
    ContentData,
    StyledLink,
    ContentDataTitle,
} from './styles'
import ImageTime from 'src/assets/Blog/imagetime2.avif'
import ImagePerson from 'src/assets/Blog/imageperson.avif'
import { useTranslation } from 'react-i18next'

export const MapSecrets = ({
    fields,
    sys,
    index,
}: PropsSectionTree & { index: number }) => {
    const { i18n } = useTranslation()
    const URL = fields?.imageOne?.fields?.file?.url
        ? fields.imageOne.fields.file.url
        : ''
    const width = index % 3 === 0 ? '477px' : '398px'
    const widthTablet = index % 3 === 0 ? '51%' : '48%'
    const uploadDate = sys?.createdAt
        ? formatDistanceToNow(new Date(sys.createdAt), { addSuffix: true })
        : ''
    const uploadDateEs = sys?.createdAt
        ? formatDistanceToNow(new Date(sys.createdAt), {
              addSuffix: true,
              locale: es,
          })
        : ''
    return (
        <Container width={width} widthTablet={widthTablet}>
            <StyledLink to={`/blog/${sys?.id}`}>
                <Image src={URL} alt={fields?.tittleContent || ''} />
                <OverSpan></OverSpan>
                <ContentInformation
                    paddingBottom={'medium'}
                    paddingTop={'medium'}
                >
                    <ContentDataTitle>
                        {i18n.language === 'es' ? (
                            <TitleTypography
                                variant={'h2'}
                                fontSize={[
                                    'xxsmall',
                                    'xxsmall',
                                    'xxsmall',
                                    'xxxsmall',
                                ]}
                                fontWeight={700}
                            >
                                {fields?.tittleContentEs || ''}
                            </TitleTypography>
                        ) : (
                            <TitleTypography
                                variant={'h2'}
                                fontSize={[
                                    'xxsmall',
                                    'xxsmall',
                                    'xxsmall',
                                    'xxxsmall',
                                ]}
                                fontWeight={700}
                            >
                                {fields?.tittleContent || ''}
                            </TitleTypography>
                        )}
                        {i18n.language === 'es' ? (
                            <TitleTypography
                                variant={'h2'}
                                fontSize={['small', 'small', 'small', 'xsmall']}
                                fontWeight={500}
                            >
                                {fields?.descriptionEs || ''}
                            </TitleTypography>
                        ) : (
                            <TitleTypography
                                variant={'h2'}
                                fontSize={['small', 'small', 'small', 'xsmall']}
                                fontWeight={500}
                            >
                                {fields?.description || ''}
                            </TitleTypography>
                        )}
                    </ContentDataTitle>
                    <DateAndCreation>
                        <ContentData marginRight={'xxxsmall'}>
                            <ImageIcon src={ImageTime} alt={fields?.tittle} />
                            {i18n.language === 'es' ? (
                                <TypographyDate
                                    variant={'h3'}
                                    fontSize={'xxsmall'}
                                    fontWeight={400}
                                >
                                    {uploadDateEs}
                                </TypographyDate>
                            ) : (
                                <TypographyDate
                                    variant={'h3'}
                                    fontSize={'xxsmall'}
                                    fontWeight={400}
                                >
                                    {uploadDate}
                                </TypographyDate>
                            )}
                        </ContentData>
                        <ContentData>
                            <ImageIcon src={ImagePerson} alt={fields?.tittle} />
                            <TypographyDate
                                variant={'h3'}
                                fontSize={'xxsmall'}
                                fontWeight={400}
                            >
                                {fields?.authorName || ''}
                            </TypographyDate>
                        </ContentData>
                    </DateAndCreation>
                </ContentInformation>
            </StyledLink>
        </Container>
    )
}
